import { render } from "./PublicationBranding.vue.js?vue&type=template&id=3cf64de4&scoped=true!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PublicationBranding.vue?vue&type=template&id=3cf64de4&scoped=true"
import script from "./PublicationBranding.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PublicationBranding.vue?vue&type=script&lang=js"
export * from "./PublicationBranding.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PublicationBranding.vue?vue&type=script&lang=js"

import "./PublicationBranding.vue.css?vue&type=style&index=0&id=3cf64de4&scoped=true&lang=css!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PublicationBranding.vue?vue&type=style&index=0&id=3cf64de4&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cf64de4"],['__file',"src/Web/scripts/pages/publication/PublicationBranding.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3cf64de4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3cf64de4', __exports__)) {
    api.reload('3cf64de4', __exports__)
  }
  
  module.hot.accept("./PublicationBranding.vue.js?vue&type=template&id=3cf64de4&scoped=true!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PublicationBranding.vue?vue&type=template&id=3cf64de4&scoped=true", () => {
    api.rerender('3cf64de4', render)
  })

}


export default __exports__